define(function(require){
 	'use strict';

 	var Marionette = require('marionette');

 	var template   = require('text!modals/_base/template/footer.tpl').default;
 	var Model 	   = require('modals/_base/model/model');

 	return Marionette.ItemView.extend({
 		template : template,
 		initialize : function(model){
            this.model = model;
 		}
 	});

 });
